import React from "react";
import { FaGithub, FaLinkedin, FaFreeCodeCamp } from "react-icons/fa6";
import styled from "styled-components";

const Footer = () => {
  return (
    <Wrapper className="footer">
      <div className="footer-social-icons">
        <ul>
          <li>
            <a
              aria-label="view my GitHub profile"
              className="social-icon"
              href="https://github.com/Hallelujah78"
            >
              <FaGithub />
            </a>
          </li>

          <li>
            <a
              aria-label="view my LinkedIn profile"
              className="social-icon"
              href="https://www.linkedin.com/in/gavan-browne/"
            >
              <FaLinkedin />
            </a>
          </li>

          <li>
            <a
              aria-label="view my freecodecamp profile"
              className="social-icon"
              href="https://www.freecodecamp.org/hallelujah78"
            >
              <FaFreeCodeCamp />
            </a>
          </li>
        </ul>
      </div>
      <p className="copyright">
        &copy; Gavan Browne {new Date().getFullYear()}
      </p>
    </Wrapper>
  );
};

export default Footer;

const Wrapper = styled.footer`
  .footer-social-icons {
    display: flex;
    width: 80vw;
  }

  .social-icon {
    background: transparent;
    font-size: 2.25rem;
    color: var(--white);
    -webkit-transition: var(--transition);
    transition: var(--transition);
  }
`;
